import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Box, Typography, Grid, Pagination, Container, Card, InputAdornment, Button } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import LeadService from '../../core/services/leadsService';
import toast from 'react-hot-toast';
import { debounce, throttle } from 'lodash';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { ClassNames } from '@emotion/react';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import '../ServicesMenu/servicesMenu.css';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import LogoutExpiredModal from '../../components/LogoutExpiredModal';
const useStyles = makeStyles((theme) => ({
  LeadTable: {
    overflowX: 'auto',
    width: 'auto',
    borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },
  // adminJobsContainer: {
  //   [theme.breakpoints.down('md')]: {
  //     width: '1000px',
  //     margin: '0 auto',
  //   },
  // },
}));
const JobsAdmin = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const theme = useTheme();
  const [chartData, setChartData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [getAllJobs, setGetAllJobs] = useState([]);
  const [JobsCount, setJobsCount] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [jobType, setJobType] = useState('');
  const [selectedFilterValue, setSelectedFilterValue] = useState('');
  const [HighestCount, setHighestCount] = useState(0);
  const [logOutModal, setLogOutModal] = React.useState(false);

  const chartRef = useRef(null);
  const abortControllerRef = useRef(null);

  const options = [
    { label: 'All', value: '' },
    { label: 'Schedule a Tour', value: 'meeting' },
    { label: 'Services', value: 'service' },
    { label: 'Home valuation', value: 'valuation' },
  ]
  const autoCompleteData = [
    { label: 'All', value: '' },
    { label: 'Schedule a Tour', value: 'meeting' },
    { label: 'Services', value: 'service' },
    { label: 'Home valuation', value: 'valuation' },
  ]

  const filterOptions = [];

  for (let i = 1; i <= 24; i++) {
    filterOptions.push({ label: `${i} Hours`, value: i });
  }
  const handleNavigateJobDetailsPage = (id, type) => {
    if (type === 'Schedule a tour' || type === 'Home valuation') {
      const job_type = 'meeting';
      navigate(`/admin-job-details/${id}`, { state: { job_type: job_type } });
    } else if (type === 'Services') {
      const job_type = 'service';
      navigate(`/admin-Services-details/${id}`, { state: { job_type: job_type } });
    } else {
      toast.error("routes not found");
    }
  };

  const columns = [
    {
      accessorKey: 'id',
      header: 'Sr no',
      size: 20,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },
    // {
    //   accessorKey: 'profile_image',
    //   header: '',
    //   Cell: ({ row }) => (
    //     <div style={{ display: 'flex', alignItems: 'center' }}>
    //       <Avatar />
    //     </div>
    //   ),
    //   enableSorting: false,
    //   size: 20,

    // },
    {
      accessorFn: (row) => {
        if (row?.last_name === null) {
          return row?.first_name;
        } else {
          return `${row?.first_name} ${row?.last_name}`;
        }
      },
      header: 'User Name',
      enableColumnActions: false,
      showColumnFilters: false,
      enableColumnFilter: false,
      enableSorting: false,
      size: 'auto',
      muiTableHeadCellProps: {
        align: 'left',
        sx: {
          fontSize: '14px',
        },
      },
    },
    {
      accessorKey: 'email',
      header: 'Email ID',
      // enableClickToCopy: true,
      enableSorting: false,
      enableColumnActions: false,
      showColumnFilters: false,
      size: 'auto',
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },

    {
      accessorKey: 'phone',
      header: 'Phone Number',
      enableSorting: false,
      size: 'auto',
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },
    {
      accessorFn: (row) => {
        const assignTo = row?.assign_to;
        if (!assignTo) {
          return '';
        }
        return assignTo.last_name ? `${assignTo.name} ${assignTo.last_name}` : assignTo.name;
      },
      header: 'Assign To',
      enableSorting: false,
      size: 'auto',
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },

    },
    {
      accessorKey: 'type',
      header: 'Opportunity Type',
      size: 'auto',
      enableSorting: false,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },
    // {
    //   accessorKey: 'member',
    //   header: 'Member Since',
    //   size: 50,
    //   muiTableHeadCellProps: {
    //     sx: {
    //       fontSize: '12px',
    //     },
    //   },
    // },
    {
      id: 'actions',
      enableSorting: false,
      header: 'See More',
      Cell: ({ row }) => {
        return (
          <div style={{ display: 'flex' }}>
            <IconButton aria-label="view" onClick={() => handleNavigateJobDetailsPage(row?.id, row?.original.type)}>
                <div style={{ display: 'flex' }}>
                  <VisibilityIcon />
                </div>
              </IconButton>
          </div>
        );
      },
      size: 50,
      muiTableHeadCellProps: {
        sx: {
          fontSize: '14px',
        },
      },
    },
  ]

  useEffect(() => {
    const labels = JobsCount?.map(data => data.month + ' ' + data.year);
    const chartData = JobsCount?.map(data => data.count);
    const initialData = {
      labels: labels,
      datasets: [
        {
          data: chartData,
          backgroundColor: ['#00BF2A', '#7400C2', '#ED7DB1', '#6EA478', '#4C489B', '#6691CB', '#FDCA40', '#F17105', '#9B5B5B', '#ED0423', '#8f95e2', '#aa6c9e'],
          borderWidth: 0,
          borderRadius: 18,
          categoryPercentage: 0.7,
        },
      ],
    };
    setChartData(initialData);
  }, [JobsCount]);

  useEffect(() => {
    if (chartData && chartRef.current) {
      Chart.defaults.font.size = 10;
      Chart.defaults.font.weight = 'bold';
      const myChart = new Chart(chartRef.current, {
        type: 'bar',
        data: chartData,
        options: {
          plugins: {
            datalabels: {
              color: 'black',
              anchor: 'end',
              align: 'end',
              formatter: (value, context) => value,
              font: {
                weight: 'bold',
                size: 12,
              },
            },
            tooltip: {
              mode: 'index',
              intersect: false,
              displayColors: false,
              callbacks: {
                label: function (context) {
                  var label = context.dataset.label || '';
                  if (label) {
                    label += ': ';
                  }
                  if (context.parsed.y !== null) {
                    label += context.parsed.y;
                  }
                  return label;
                },
              },
              bodyFontColor: function (context) {
                var dataset = context.dataset;
                var index = context.dataIndex;
                var value = dataset.data[index];
                return dataset.backgroundColor[index];
              },
            },
            legend: {
              display: false,
              position: 'top',
              labels: {
                font: {
                  size: 16,
                  weight: 'bold',
                },
              },
            },
            title: {
              display: false,
              text: 'Status Overview',
              position: 'top',
              align: 'start',
              font: {
                size: 20,
                weight: 'bold',
              },
              padding: 20,
            },
          },
          scales: {
            y: {
              beginAtZero: false,
              min: 0,
              max: HighestCount + 10,
            },
            x: {
              grid: {
                display: false,
              },
            },
          },
          layout: {
            padding: {
              left: 30,
              right: 30,
              top: 10,
              bottom: 10,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
        },
        plugins: [ChartDataLabels],
      });

      return () => {
        myChart.destroy();
      };
    }
  }, [chartData]);

  const getJobs = async (currentPage, searchTerm, selectedValue = '', signal) => {
    try {

      const res = await LeadService.getJobs(currentPage, searchTerm, selectedValue, { signal });
      if (res.data.success) {
        setGetAllJobs(res?.data?.jobs?.data);
        setCurrentPage(res?.data?.jobs?.current_page);
        setTotalPages(Math.ceil(res?.data?.jobs?.total / res?.data?.jobs?.per_page));
      }

    } catch (error) {
      if (error.message === 'You have been logged out of the application, please login again to use the application.') {
        setLogOutModal(true);
    } else {
        toast.error(error.message);
    }
    } finally {

      setIsLoading(false);
    }

  }

  // Throttled function to ensure a minimum delay of 2 seconds between calls
  const throttledGetJobs = useCallback(
    throttle((currentPage, searchTerm, selectedValue, signal) => {
      getJobs(currentPage, searchTerm, selectedValue, signal);
    }, 2000), []
  );

  // Debounced function to delay the API call until the user stops typing
  const fetchJobs = useCallback(
    debounce((currentPage, searchTerm, selectedValue) => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      const abortController = new AbortController();
      abortControllerRef.current = abortController;
      throttledGetJobs(currentPage, searchTerm, selectedValue, abortController.signal);
    }, 300), [throttledGetJobs]
  );

  useEffect(() => {
    fetchJobs(currentPage, searchTerm, selectedValue);
    const savedSearchTerm = localStorage.getItem('searchTerm');
    if (savedSearchTerm) {
        setSearchTerm(JSON.parse(savedSearchTerm));
    }
  }, [currentPage, searchTerm, selectedValue, fetchJobs]);

  const handleSearchChange = (event) => {
    const newSearchValue = event.target.value;
    setSearchTerm(newSearchValue);
    if(newSearchValue!== null){
        localStorage.setItem('searchTerm', JSON.stringify(newSearchValue));
    } else {
        localStorage.removeItem('searchTerm'); 
    }
    setCurrentPage(1);
  };

  const HandleChangeValue = async (event, newValue) => {
    setSelectedValue(newValue ? newValue.value : '')
    setCurrentPage(1);
  }


  const handleClear = () => {
    localStorage.removeItem('searchTerm'); 
    setSearchTerm('');
    setCurrentPage(1);
    fetchJobs(1, '');
  };

  const getMonthlyJob = async (jobType = '') => {
    try {
      const res = await LeadService.MonthlyJobCounts(jobType);
      if (res.data.success) {
        setJobsCount(res?.data?.JobCount);
        setHighestCount(res?.data?.highestCount);
      }

    } catch (error) {
      toast.error(error.message);

    }
  }
  const HandleChangeJobType = async (event, newValue) => {
    await setJobType(newValue?.value)
  }
  const HandleChangeFilter = async (event, newValue) => {
    setSelectedFilterValue(newValue ? newValue.value : '')
    setCurrentPage(1);
  }
  useEffect(() => {
    getMonthlyJob(jobType);
  }, [jobType]);

  const handleNavigateSchedule = () => {
    navigate('/ViewAllJobRoutes')
  }
  return (
    <div
      className={classes.adminJobsContainer}
    >
      <Box>
        <Typography className="services-animated-text">Opportunities</Typography>
      </Box>
      <Box style={{ marginTop: '30px' }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
          <Box style={{ display: 'flex', gap: '10px' }}>
            {/* <Autocomplete
              options={filterOptions}
              getOptionLabel={(filterOptions) => filterOptions.label}
              renderInput={(params) => <TextField {...params} label="Hours" />}
              sx={{ width: 250 }}
              value={filterOptions.find(filterOptions => filterOptions.value === selectedFilterValue) || null}
              onChange={HandleChangeFilter}
              disabled={isLoading}
            />
            <Button variant="outlined" onClick={handleNavigateSchedule} 
            disabled={!selectedFilterValue || isLoading} 
            style={{ textTransform: 'capitalize', borderRadius: '8px' }}>Show All</Button> */}
          </Box>

          <Box style={{ display: 'flex', gap: '10px' }}>
            <Autocomplete
              options={options}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} label="Select" />}
              value={options.find(option => option.value === selectedValue) || null}
              onChange={HandleChangeValue}
              disabled={isLoading}
              sx={{ width: {
                xs: "150px",
                sm: "200px",
                md: "250px"
              } ,'& .MuiOutlinedInput-root': {
                borderRadius: '12px',
            },}}
            />
            <TextField
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search by name , email"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClear} aria-label="clear search">
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              sx={{ width: {
                xs: "150px",
                sm: "200px",
                md: "250px"
              } ,'& .MuiOutlinedInput-root': {
                borderRadius: '12px',
            },}}
            />
          </Box>
        </Box>
        <ThemeProvider theme={theme}>
          <GlobalStyles
            styles={{
              '::-webkit-scrollbar': {
                width: '14px', // Set the desired width for the scrollbar
              },
              '::-webkit-scrollbar-thumb': {
                backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                borderRadius: '10px', // Set the border radius for a rounded effect
              },
            }}
          />
        <div className={classes.LeadTable}>
          <MaterialReactTable
            columns={columns}
            data={getAllJobs}
            state={{ isLoading: isLoading }}
            muiCircularProgressProps={{
              color: 'secondary',
              thickness: 5,
              size: 55,
            }}
            muiSkeletonProps={{
              animation: 'pulse',
              height: 28,
            }}
            enableTopToolbar={false}
            enableFacetedValues={true}
            enableStickyHeader={true}
            enableDensityToggle={false}
            enableHiding={false}
            showSkeletons={false}
            enableColumnFilterModes={false}
            enableColumnActions={false}
            enableColumnOrdering={false}
            enableFullScreenToggle={false}
            enableColumnFilters={false}
            enablePagination={false}
            getRowId={(row) => row.id}
            initialState={{
              showColumnFilters: false,
              showGlobalFilter: false,
            }}
            muiTableBodyRowProps={{
              sx: {
                backgroundColor: '#f5f5f5', // Default row background color
                '&:nth-of-type(odd)': {
                  backgroundColor: '#ffffff', // Alternate rows with white
                },
                '&:hover': {
                  backgroundColor: '#e0e0e0', // Hover effect
                  cursor:'pointer'
                },
              },
            }}
          />
        </div>
        </ThemeProvider>

        <Pagination
          count={totalPages}
          color="primary"
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
        />
      </Box>
      <Box style={{ width: '100%', background: 'white', marginTop: '20px', borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', }}>
        <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '20px' }}>

          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>Status Overview</span>

          <Box style={{ display: 'flex', gap: '10px' }}>
            {/* <Box style={{ display: 'flex' }}>
              <Box>
                <Checkbox />
              </Box>
              <Box style={{ marginTop: '5px' }}>
                <Typography style={{ fontSize: '22px', fontWeight: '700' }}>Job Types</Typography>
              </Box>
            </Box> */}
            <div>
              {/* <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={autoCompleteData}
                sx={{ width: 230, }}
                size="small"
                renderInput={(params) => <TextField {...params} label="Select" />}
              /> */}
              <Autocomplete
                options={autoCompleteData}
                getOptionLabel={(autoCompleteData) => autoCompleteData.label}
                renderInput={(params) => <TextField {...params} label="Select" />}
                sx={{ width: 230, }}
                size="small"
                value={options.find(option => option.value === jobType) || null}
                onChange={HandleChangeJobType}
                disabled={isLoading}
              />
            </div>
          </Box>
        </Box>
        <Box style={{ position: 'relative', height: '400px' }}>
          <canvas ref={chartRef} style={{ width: '100%', height: '100%' }}></canvas>
        </Box>
      </Box>
      <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal}/>
    </div>
  )
}
export default JobsAdmin
